import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Endfooter from "../Homecomponents/Endfooter";
import Superheader from "../KalHome/Superheader";

const Register = () => {
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Check if the passwords match
  //   if (formData.password !== formData.confirmPassword) {
  //     setError("Passwords do not match.");
  //     return;
  //   }

  //   setError("");

  //   try {
  //     // Fetch all registered users to check if email or mobile already exists
  //     const allUsersResponse = await axios.get(
  //       "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
  //     );
  //     const allUsers = allUsersResponse.data;

  //     // Check if the email or mobile already exists
  //     const isEmailExist = allUsers.some(
  //       (user) => user.email === formData.email
  //     );
  //     const isMobileExist = allUsers.some(
  //       (user) => user.mobile === formData.mobile
  //     );

  //     if (isEmailExist || isMobileExist) {
  //       setError(
  //         "Email or Mobile Number already exists. Please sign in instead."
  //       );
  //       return;
  //     }

  //     // If not exists, proceed with registration
  //     const response = await axios.post(
  //       "https://api.dremerz.net/api/Kalanjiyam_Users_Registration",
  //       formData
  //     );

  //     if (response.status === 200) {
  //       setSuccess(
  //         `Welcome, ${formData.fullname}! Your registration was successful.`
  //       );
  //       setFormData({
  //         fullname: "",
  //         email: "",
  //         mobile: "",
  //         password: "",
  //         confirmPassword: "",
  //       });

  //       // Redirect to the home page after successful registration
  //       navigate("/"); // Redirect to home page
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     setError("Registration failed. Please try again.");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the passwords match
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError("");

    try {
      // Fetch all registered users to check if email or mobile already exists
      const allUsersResponse = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
      );
      const allUsers = allUsersResponse.data;

      // Check if the email or mobile already exists
      const isEmailExist = allUsers.some(
        (user) => user.email === formData.email
      );
      const isMobileExist = allUsers.some(
        (user) => user.mobile === formData.mobile
      );

      if (isEmailExist || isMobileExist) {
        setError(
          "Email or Mobile Number already exists. Please sign in instead."
        );
        return;
      }

      // If not exists, proceed with registration
      const response = await axios.post(
        "https://api.dremerz.net/api/Kalanjiyam_Users_Registration",
        formData
      );

      if (response.status === 200) {
        setSuccess(
          `Welcome, ${formData.fullname}! Your registration was successful.`
        );

        // Save user data to session storage
        sessionStorage.setItem(
          "user",
          JSON.stringify({
            fullname: formData.fullname,
            email: formData.email,
            mobile: formData.mobile,
          })
        );

        // Reset the form data
        setFormData({
          fullname: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
        });

        // Redirect to the home page
        navigate("/"); // Redirect to home page
      }
    } catch (err) {
      console.error(err);
      setError("Registration failed. Please try again.");
    }
  };

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>      <div className="registration-wrapper">
        <div className="registration-container">
          <div className="registration-left">
            <div className="logo-container">
              <a href="/">
                <div className="logo-container mb-2">
                  <a href="/">
                    <div
                      className="mainlogotitle"
                      style={{ fontSize: "34px", fontFamily: "kalanjiyamfont", color:'white' }}
                    >
                      Kalanjiyam
                      <br></br>
                      <span
                        style={{
                          fontSize: "24px",
                          fontFamily: "botiquefont",
                          marginLeft: "100px",
                          color:"white"
                        }}
                      >
                        Boutique.
                      </span>
                    </div>
                  </a>
                </div>
              </a>
            </div>
            <p className="registration-powered">
              “Where even mannequins come alive”
            </p>
            <p className="welcome-message">
              Join us and start your journey today!
            </p>
          </div>

          <div className="registration-right">
            <h2 className="hello">Registration</h2>
            {success ? (
              <p className="success-message">{success}</p>
            ) : (
              <form className="registration-form" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="fullname"
                    placeholder="Full Name"
                    value={formData.fullname}
                    onChange={handleChange}
                    required
                    className="form-control registration-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-control registration-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                    className="form-control registration-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="form-control registration-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    className="form-control registration-input"
                  />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button className="btn registration-submit" type="submit">
                  Register
                </button>
              </form>
            )}
            <div className="already-have-account">
              <p>
                Already have an account?{" "}
                <span>
                  <a href="/login" className="sign-in-link">
                    Sign In!
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Endfooter />
    </>
  );
};

export default Register;
